/**
 * Generated by orval v8.0.0 🍺
 * Do not edit manually.
 * FabControl API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddPurchaseOrderCommentRequest,
  AddPurchaseOrderCommentResponse,
  BaseResponse,
  DeliveriesSuccessResponse,
  DrawingsSuccessResponse,
  IssueDeliveryResponse,
  IssuesSuccessResponse,
  MaterialAvailabilityResponse,
  MrbSuccessResponse,
  PoCommandCenterSuccessResponse,
  PoLinesSuccessResponse,
  PurchaseOrderCommentsSuccessResponse,
  PurchaseOrdersAddCommentPathParameters,
  PurchaseOrdersGetAllClosedParams,
  PurchaseOrdersGetAllClosedPathParameters,
  PurchaseOrdersGetAllOpenParams,
  PurchaseOrdersGetAllOpenPathParameters,
  PurchaseOrdersGetByIdPathParameters,
  PurchaseOrdersGetCommentsPathParameters,
  PurchaseOrdersGetDeliveriesByIdPathParameters,
  PurchaseOrdersGetDrawingsByIdPathParameters,
  PurchaseOrdersGetIssuesByIdPathParameters,
  PurchaseOrdersGetMaterialAvailabilityPathParameters,
  PurchaseOrdersGetMrbByIdPathParameters,
  PurchaseOrdersGetPoLinesByIdParams,
  PurchaseOrdersGetPoLinesByIdPathParameters,
  PurchaseOrdersGetQualityByIdPathParameters,
  PurchaseOrdersGetSpoolsByIdParams,
  PurchaseOrdersGetSpoolsByIdPathParameters,
  PurchaseOrdersIssueDeliveryPathParameters,
  PurchaseOrdersSuccessResponse,
  PurchaseOrdersUpdateDeliveryNotesPathParameters,
  PurchaseOrdersUpdatePriorityPathParameters,
  QualitySuccessResponse,
  SpoolsSuccessResponse,
  UpdateDeliveryNotesRequest,
  UpdateDeliveryNotesResponse,
  UpdatePurchaseOrderPriorityRequest,
  UpdatePurchaseOrderPriorityResponse
} from '.././model';

import { apiInstance } from '../../instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get all open purchase orders
 */
export const purchaseOrdersGetAllOpen = (
    { identifier }: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PurchaseOrdersSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getAllOpen`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPurchaseOrdersGetAllOpenQueryKey = ({ identifier }: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams,) => {
    return [
    `/api/purchaseorders/${identifier}/getAllOpen`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getPurchaseOrdersGetAllOpenQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>({ identifier }: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetAllOpenQueryKey({ identifier },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>> = ({ signal }) => purchaseOrdersGetAllOpen({ identifier },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetAllOpenQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>>
export type PurchaseOrdersGetAllOpenQueryError = BaseResponse


export function usePurchaseOrdersGetAllOpen<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllOpenPathParameters,
    params: undefined |  PurchaseOrdersGetAllOpenParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllOpen<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllOpen<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all open purchase orders
 */

export function usePurchaseOrdersGetAllOpen<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 { identifier }: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetAllOpenQueryOptions({ identifier },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetAllOpenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>({ identifier }: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetAllOpenQueryKey({ identifier },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>> = ({ signal }) => purchaseOrdersGetAllOpen({ identifier },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetAllOpenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>>
export type PurchaseOrdersGetAllOpenSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetAllOpenSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllOpenPathParameters,
    params: undefined |  PurchaseOrdersGetAllOpenParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllOpenSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllOpenSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all open purchase orders
 */

export function usePurchaseOrdersGetAllOpenSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError = BaseResponse>(
 { identifier }: PurchaseOrdersGetAllOpenPathParameters,
    params?: PurchaseOrdersGetAllOpenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllOpen>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetAllOpenSuspenseQueryOptions({ identifier },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get all closed purchase orders
 */
export const purchaseOrdersGetAllClosed = (
    { identifier }: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PurchaseOrdersSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getAllClosed`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPurchaseOrdersGetAllClosedQueryKey = ({ identifier }: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams,) => {
    return [
    `/api/purchaseorders/${identifier}/getAllClosed`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getPurchaseOrdersGetAllClosedQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>({ identifier }: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetAllClosedQueryKey({ identifier },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>> = ({ signal }) => purchaseOrdersGetAllClosed({ identifier },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetAllClosedQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>>
export type PurchaseOrdersGetAllClosedQueryError = BaseResponse


export function usePurchaseOrdersGetAllClosed<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllClosedPathParameters,
    params: undefined |  PurchaseOrdersGetAllClosedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllClosed<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllClosed<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all closed purchase orders
 */

export function usePurchaseOrdersGetAllClosed<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 { identifier }: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetAllClosedQueryOptions({ identifier },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetAllClosedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>({ identifier }: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetAllClosedQueryKey({ identifier },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>> = ({ signal }) => purchaseOrdersGetAllClosed({ identifier },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetAllClosedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>>
export type PurchaseOrdersGetAllClosedSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetAllClosedSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllClosedPathParameters,
    params: undefined |  PurchaseOrdersGetAllClosedParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllClosedSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetAllClosedSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all closed purchase orders
 */

export function usePurchaseOrdersGetAllClosedSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError = BaseResponse>(
 { identifier }: PurchaseOrdersGetAllClosedPathParameters,
    params?: PurchaseOrdersGetAllClosedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetAllClosed>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetAllClosedSuspenseQueryOptions({ identifier },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get purchase order command center details
 */
export const purchaseOrdersGetById = (
    { identifier, id }: PurchaseOrdersGetByIdPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoCommandCenterSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getById/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetByIdPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getById/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetById>>> = ({ signal }) => purchaseOrdersGetById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetById>>>
export type PurchaseOrdersGetByIdQueryError = BaseResponse


export function usePurchaseOrdersGetById<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetByIdPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetById<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetById<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get purchase order command center details
 */

export function usePurchaseOrdersGetById<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetByIdQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetById>>> = ({ signal }) => purchaseOrdersGetById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetById>>>
export type PurchaseOrdersGetByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetByIdPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get purchase order command center details
 */

export function usePurchaseOrdersGetByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetByIdSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get PO lines by Purchase Order id
 */
export const purchaseOrdersGetPoLinesById = (
    { identifier, id }: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PoLinesSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getPoLinesById/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPurchaseOrdersGetPoLinesByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams,) => {
    return [
    `/api/purchaseorders/${identifier}/getPoLinesById/${id}`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getPurchaseOrdersGetPoLinesByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetPoLinesByIdQueryKey({ identifier, id },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>> = ({ signal }) => purchaseOrdersGetPoLinesById({ identifier, id },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetPoLinesByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>>
export type PurchaseOrdersGetPoLinesByIdQueryError = BaseResponse


export function usePurchaseOrdersGetPoLinesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetPoLinesByIdPathParameters,
    params: undefined |  PurchaseOrdersGetPoLinesByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetPoLinesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetPoLinesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO lines by Purchase Order id
 */

export function usePurchaseOrdersGetPoLinesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetPoLinesByIdQueryOptions({ identifier, id },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetPoLinesByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetPoLinesByIdQueryKey({ identifier, id },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>> = ({ signal }) => purchaseOrdersGetPoLinesById({ identifier, id },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetPoLinesByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>>
export type PurchaseOrdersGetPoLinesByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetPoLinesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetPoLinesByIdPathParameters,
    params: undefined |  PurchaseOrdersGetPoLinesByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetPoLinesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetPoLinesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get PO lines by Purchase Order id
 */

export function usePurchaseOrdersGetPoLinesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetPoLinesByIdPathParameters,
    params?: PurchaseOrdersGetPoLinesByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetPoLinesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetPoLinesByIdSuspenseQueryOptions({ identifier, id },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get deliveries by Purchase Order id
 */
export const purchaseOrdersGetDeliveriesById = (
    { identifier, id }: PurchaseOrdersGetDeliveriesByIdPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<DeliveriesSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getDeliveriesById/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetDeliveriesByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetDeliveriesByIdPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getDeliveriesById/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetDeliveriesByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetDeliveriesByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>> = ({ signal }) => purchaseOrdersGetDeliveriesById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetDeliveriesByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>>
export type PurchaseOrdersGetDeliveriesByIdQueryError = BaseResponse


export function usePurchaseOrdersGetDeliveriesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDeliveriesByIdPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDeliveriesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDeliveriesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get deliveries by Purchase Order id
 */

export function usePurchaseOrdersGetDeliveriesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetDeliveriesByIdQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetDeliveriesByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetDeliveriesByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>> = ({ signal }) => purchaseOrdersGetDeliveriesById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetDeliveriesByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>>
export type PurchaseOrdersGetDeliveriesByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetDeliveriesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDeliveriesByIdPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDeliveriesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDeliveriesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get deliveries by Purchase Order id
 */

export function usePurchaseOrdersGetDeliveriesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetDeliveriesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDeliveriesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetDeliveriesByIdSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get drawings and revisions by Purchase Order id
 */
export const purchaseOrdersGetDrawingsById = (
    { identifier, id }: PurchaseOrdersGetDrawingsByIdPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<DrawingsSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getDrawingsById/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetDrawingsByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetDrawingsByIdPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getDrawingsById/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetDrawingsByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetDrawingsByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>> = ({ signal }) => purchaseOrdersGetDrawingsById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetDrawingsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>>
export type PurchaseOrdersGetDrawingsByIdQueryError = BaseResponse


export function usePurchaseOrdersGetDrawingsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDrawingsByIdPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDrawingsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDrawingsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get drawings and revisions by Purchase Order id
 */

export function usePurchaseOrdersGetDrawingsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetDrawingsByIdQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetDrawingsByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetDrawingsByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>> = ({ signal }) => purchaseOrdersGetDrawingsById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetDrawingsByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>>
export type PurchaseOrdersGetDrawingsByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetDrawingsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDrawingsByIdPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDrawingsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetDrawingsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get drawings and revisions by Purchase Order id
 */

export function usePurchaseOrdersGetDrawingsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetDrawingsByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetDrawingsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetDrawingsByIdSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get spools by Purchase Order id
 */
export const purchaseOrdersGetSpoolsById = (
    { identifier, id }: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<SpoolsSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getSpoolsById/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPurchaseOrdersGetSpoolsByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams,) => {
    return [
    `/api/purchaseorders/${identifier}/getSpoolsById/${id}`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getPurchaseOrdersGetSpoolsByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetSpoolsByIdQueryKey({ identifier, id },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>> = ({ signal }) => purchaseOrdersGetSpoolsById({ identifier, id },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetSpoolsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>>
export type PurchaseOrdersGetSpoolsByIdQueryError = BaseResponse


export function usePurchaseOrdersGetSpoolsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetSpoolsByIdPathParameters,
    params: undefined |  PurchaseOrdersGetSpoolsByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetSpoolsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetSpoolsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get spools by Purchase Order id
 */

export function usePurchaseOrdersGetSpoolsById<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetSpoolsByIdQueryOptions({ identifier, id },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetSpoolsByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetSpoolsByIdQueryKey({ identifier, id },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>> = ({ signal }) => purchaseOrdersGetSpoolsById({ identifier, id },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetSpoolsByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>>
export type PurchaseOrdersGetSpoolsByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetSpoolsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetSpoolsByIdPathParameters,
    params: undefined |  PurchaseOrdersGetSpoolsByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetSpoolsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetSpoolsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get spools by Purchase Order id
 */

export function usePurchaseOrdersGetSpoolsByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetSpoolsByIdPathParameters,
    params?: PurchaseOrdersGetSpoolsByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetSpoolsById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetSpoolsByIdSuspenseQueryOptions({ identifier, id },params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get quality (ITP / QC / NDT / Dimensional) by Purchase Order id
 */
export const purchaseOrdersGetQualityById = (
    { identifier, id }: PurchaseOrdersGetQualityByIdPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<QualitySuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getQualityById/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetQualityByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetQualityByIdPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getQualityById/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetQualityByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetQualityByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>> = ({ signal }) => purchaseOrdersGetQualityById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetQualityByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>>
export type PurchaseOrdersGetQualityByIdQueryError = BaseResponse


export function usePurchaseOrdersGetQualityById<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetQualityByIdPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetQualityById<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetQualityById<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quality (ITP / QC / NDT / Dimensional) by Purchase Order id
 */

export function usePurchaseOrdersGetQualityById<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetQualityByIdQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetQualityByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetQualityByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>> = ({ signal }) => purchaseOrdersGetQualityById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetQualityByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>>
export type PurchaseOrdersGetQualityByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetQualityByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetQualityByIdPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetQualityByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetQualityByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get quality (ITP / QC / NDT / Dimensional) by Purchase Order id
 */

export function usePurchaseOrdersGetQualityByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetQualityByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetQualityById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetQualityByIdSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get MRB packages by Purchase Order id
 */
export const purchaseOrdersGetMrbById = (
    { identifier, id }: PurchaseOrdersGetMrbByIdPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<MrbSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getMrbById/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetMrbByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetMrbByIdPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getMrbById/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetMrbByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetMrbByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>> = ({ signal }) => purchaseOrdersGetMrbById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetMrbByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>>
export type PurchaseOrdersGetMrbByIdQueryError = BaseResponse


export function usePurchaseOrdersGetMrbById<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMrbByIdPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMrbById<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMrbById<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get MRB packages by Purchase Order id
 */

export function usePurchaseOrdersGetMrbById<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetMrbByIdQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetMrbByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetMrbByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>> = ({ signal }) => purchaseOrdersGetMrbById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetMrbByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>>
export type PurchaseOrdersGetMrbByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetMrbByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMrbByIdPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMrbByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMrbByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get MRB packages by Purchase Order id
 */

export function usePurchaseOrdersGetMrbByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetMrbByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMrbById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetMrbByIdSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get issues (NCR / RFI / TQ) by Purchase Order id
 */
export const purchaseOrdersGetIssuesById = (
    { identifier, id }: PurchaseOrdersGetIssuesByIdPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<IssuesSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getIssuesById/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetIssuesByIdQueryKey = ({ identifier, id }: PurchaseOrdersGetIssuesByIdPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getIssuesById/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetIssuesByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetIssuesByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>> = ({ signal }) => purchaseOrdersGetIssuesById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetIssuesByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>>
export type PurchaseOrdersGetIssuesByIdQueryError = BaseResponse


export function usePurchaseOrdersGetIssuesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetIssuesByIdPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetIssuesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetIssuesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get issues (NCR / RFI / TQ) by Purchase Order id
 */

export function usePurchaseOrdersGetIssuesById<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetIssuesByIdQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetIssuesByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetIssuesByIdQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>> = ({ signal }) => purchaseOrdersGetIssuesById({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetIssuesByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>>
export type PurchaseOrdersGetIssuesByIdSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetIssuesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetIssuesByIdPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetIssuesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetIssuesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get issues (NCR / RFI / TQ) by Purchase Order id
 */

export function usePurchaseOrdersGetIssuesByIdSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetIssuesByIdPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetIssuesById>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetIssuesByIdSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Update purchase order priority
 */
export const purchaseOrdersUpdatePriority = (
    { identifier, id }: PurchaseOrdersUpdatePriorityPathParameters,
    updatePurchaseOrderPriorityRequest: UpdatePurchaseOrderPriorityRequest,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<UpdatePurchaseOrderPriorityResponse>(
      {url: `/api/purchaseorders/${identifier}/updatePriority/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePurchaseOrderPriorityRequest, signal
    },
      options);
    }
  


export const getPurchaseOrdersUpdatePriorityMutationOptions = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersUpdatePriority>>, TError,{pathParams: PurchaseOrdersUpdatePriorityPathParameters;data: UpdatePurchaseOrderPriorityRequest}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersUpdatePriority>>, TError,{pathParams: PurchaseOrdersUpdatePriorityPathParameters;data: UpdatePurchaseOrderPriorityRequest}, TContext> => {

const mutationKey = ['purchaseOrdersUpdatePriority'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};



      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchaseOrdersUpdatePriority>>, {pathParams: PurchaseOrdersUpdatePriorityPathParameters;data: UpdatePurchaseOrderPriorityRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  purchaseOrdersUpdatePriority(pathParams,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PurchaseOrdersUpdatePriorityMutationResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersUpdatePriority>>>
    export type PurchaseOrdersUpdatePriorityMutationBody = UpdatePurchaseOrderPriorityRequest
    export type PurchaseOrdersUpdatePriorityMutationError = BaseResponse

    /**
 * @summary Update purchase order priority
 */
export const usePurchaseOrdersUpdatePriority = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersUpdatePriority>>, TError,{pathParams: PurchaseOrdersUpdatePriorityPathParameters;data: UpdatePurchaseOrderPriorityRequest}, TContext>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purchaseOrdersUpdatePriority>>,
        TError,
        {pathParams: PurchaseOrdersUpdatePriorityPathParameters;data: UpdatePurchaseOrderPriorityRequest},
        TContext
      > => {
      return useMutation(getPurchaseOrdersUpdatePriorityMutationOptions(options), queryClient);
    }
    /**
 * Updates only the Notes field of a delivery
 * @summary Update delivery notes
 */
export const purchaseOrdersUpdateDeliveryNotes = (
    { identifier, id }: PurchaseOrdersUpdateDeliveryNotesPathParameters,
    updateDeliveryNotesRequest: UpdateDeliveryNotesRequest,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<UpdateDeliveryNotesResponse>(
      {url: `/api/purchaseorders/${identifier}/updateDeliveryNotes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDeliveryNotesRequest, signal
    },
      options);
    }
  


export const getPurchaseOrdersUpdateDeliveryNotesMutationOptions = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersUpdateDeliveryNotes>>, TError,{pathParams: PurchaseOrdersUpdateDeliveryNotesPathParameters;data: UpdateDeliveryNotesRequest}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersUpdateDeliveryNotes>>, TError,{pathParams: PurchaseOrdersUpdateDeliveryNotesPathParameters;data: UpdateDeliveryNotesRequest}, TContext> => {

const mutationKey = ['purchaseOrdersUpdateDeliveryNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};



      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchaseOrdersUpdateDeliveryNotes>>, {pathParams: PurchaseOrdersUpdateDeliveryNotesPathParameters;data: UpdateDeliveryNotesRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  purchaseOrdersUpdateDeliveryNotes(pathParams,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PurchaseOrdersUpdateDeliveryNotesMutationResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersUpdateDeliveryNotes>>>
    export type PurchaseOrdersUpdateDeliveryNotesMutationBody = UpdateDeliveryNotesRequest
    export type PurchaseOrdersUpdateDeliveryNotesMutationError = BaseResponse

    /**
 * @summary Update delivery notes
 */
export const usePurchaseOrdersUpdateDeliveryNotes = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersUpdateDeliveryNotes>>, TError,{pathParams: PurchaseOrdersUpdateDeliveryNotesPathParameters;data: UpdateDeliveryNotesRequest}, TContext>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purchaseOrdersUpdateDeliveryNotes>>,
        TError,
        {pathParams: PurchaseOrdersUpdateDeliveryNotesPathParameters;data: UpdateDeliveryNotesRequest},
        TContext
      > => {
      return useMutation(getPurchaseOrdersUpdateDeliveryNotesMutationOptions(options), queryClient);
    }
    /**
 * Every comment of the purchase order, newest first. An order without comments returns an empty list. Every user of the tenant can read them. Comments are kept in Prefab only (not synced with IFS) and cannot be edited or deleted.
 * @summary Get the comments of a purchase order
 */
export const purchaseOrdersGetComments = (
    { identifier, id }: PurchaseOrdersGetCommentsPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PurchaseOrderCommentsSuccessResponse>(
      {url: `/api/purchaseorders/${identifier}/getComments/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetCommentsQueryKey = ({ identifier, id }: PurchaseOrdersGetCommentsPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getComments/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetCommentsQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetCommentsQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetComments>>> = ({ signal }) => purchaseOrdersGetComments({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetComments>>>
export type PurchaseOrdersGetCommentsQueryError = BaseResponse


export function usePurchaseOrdersGetComments<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetCommentsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetComments>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetComments<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetComments>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetComments<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the comments of a purchase order
 */

export function usePurchaseOrdersGetComments<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetCommentsQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetCommentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetCommentsQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetComments>>> = ({ signal }) => purchaseOrdersGetComments({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetCommentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetComments>>>
export type PurchaseOrdersGetCommentsSuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetCommentsSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetCommentsPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetCommentsSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetCommentsSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the comments of a purchase order
 */

export function usePurchaseOrdersGetCommentsSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetCommentsPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetComments>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetCommentsSuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Adds a comment by the signed-in user; every user of the tenant can add one. The author and the time are set by the server. The text is trimmed; an empty text, or one longer than 2000 characters, is a 400. A comment cannot be edited or deleted afterwards.
 * @summary Add a comment to a purchase order
 */
export const purchaseOrdersAddComment = (
    { identifier, id }: PurchaseOrdersAddCommentPathParameters,
    addPurchaseOrderCommentRequest: AddPurchaseOrderCommentRequest,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<AddPurchaseOrderCommentResponse>(
      {url: `/api/purchaseorders/${identifier}/addComment/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPurchaseOrderCommentRequest, signal
    },
      options);
    }
  


export const getPurchaseOrdersAddCommentMutationOptions = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersAddComment>>, TError,{pathParams: PurchaseOrdersAddCommentPathParameters;data: AddPurchaseOrderCommentRequest}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersAddComment>>, TError,{pathParams: PurchaseOrdersAddCommentPathParameters;data: AddPurchaseOrderCommentRequest}, TContext> => {

const mutationKey = ['purchaseOrdersAddComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};



      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchaseOrdersAddComment>>, {pathParams: PurchaseOrdersAddCommentPathParameters;data: AddPurchaseOrderCommentRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  purchaseOrdersAddComment(pathParams,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PurchaseOrdersAddCommentMutationResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersAddComment>>>
    export type PurchaseOrdersAddCommentMutationBody = AddPurchaseOrderCommentRequest
    export type PurchaseOrdersAddCommentMutationError = BaseResponse

    /**
 * @summary Add a comment to a purchase order
 */
export const usePurchaseOrdersAddComment = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersAddComment>>, TError,{pathParams: PurchaseOrdersAddCommentPathParameters;data: AddPurchaseOrderCommentRequest}, TContext>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purchaseOrdersAddComment>>,
        TError,
        {pathParams: PurchaseOrdersAddCommentPathParameters;data: AddPurchaseOrderCommentRequest},
        TContext
      > => {
      return useMutation(getPurchaseOrdersAddCommentMutationOptions(options), queryClient);
    }
    /**
 * Reserves the part of the delivery (MTO line) from free stock in IFS and ships it to the supplier on the IFS purchase order. IFS issues per part, so every MTO line of the same part on the order is issued together. When there is not enough free stock, what there is gets issued and the rest is returned as totalRemaining.
 * @summary Issue the material of an MTO line in IFS
 */
export const purchaseOrdersIssueDelivery = (
    { identifier, id }: PurchaseOrdersIssueDeliveryPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<IssueDeliveryResponse>(
      {url: `/api/purchaseorders/${identifier}/issueDelivery/${id}`, method: 'POST', signal
    },
      options);
    }
  


export const getPurchaseOrdersIssueDeliveryMutationOptions = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersIssueDelivery>>, TError,{pathParams: PurchaseOrdersIssueDeliveryPathParameters}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersIssueDelivery>>, TError,{pathParams: PurchaseOrdersIssueDeliveryPathParameters}, TContext> => {

const mutationKey = ['purchaseOrdersIssueDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};



      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchaseOrdersIssueDelivery>>, {pathParams: PurchaseOrdersIssueDeliveryPathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  purchaseOrdersIssueDelivery(pathParams,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PurchaseOrdersIssueDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersIssueDelivery>>>
    
    export type PurchaseOrdersIssueDeliveryMutationError = BaseResponse

    /**
 * @summary Issue the material of an MTO line in IFS
 */
export const usePurchaseOrdersIssueDelivery = <TError = BaseResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseOrdersIssueDelivery>>, TError,{pathParams: PurchaseOrdersIssueDeliveryPathParameters}, TContext>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purchaseOrdersIssueDelivery>>,
        TError,
        {pathParams: PurchaseOrdersIssueDeliveryPathParameters},
        TContext
      > => {
      return useMutation(getPurchaseOrdersIssueDeliveryMutationOptions(options), queryClient);
    }
    /**
 * For every part of the purchase order: what is required, reserved and issued, the free stock in the project, and whether that stock is enough to issue the part (canIssue). The MTO schedule disables "Issue" when it is not.
 * @summary Get the free stock in IFS of every part of a purchase order
 */
export const purchaseOrdersGetMaterialAvailability = (
    { identifier, id }: PurchaseOrdersGetMaterialAvailabilityPathParameters,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<MaterialAvailabilityResponse>(
      {url: `/api/purchaseorders/${identifier}/getMaterialAvailability/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPurchaseOrdersGetMaterialAvailabilityQueryKey = ({ identifier, id }: PurchaseOrdersGetMaterialAvailabilityPathParameters,) => {
    return [
    `/api/purchaseorders/${identifier}/getMaterialAvailability/${id}`
    ] as const;
    }

    
export const getPurchaseOrdersGetMaterialAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetMaterialAvailabilityQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>> = ({ signal }) => purchaseOrdersGetMaterialAvailability({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(identifier && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetMaterialAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>>
export type PurchaseOrdersGetMaterialAvailabilityQueryError = BaseResponse


export function usePurchaseOrdersGetMaterialAvailability<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMaterialAvailabilityPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMaterialAvailability<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMaterialAvailability<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the free stock in IFS of every part of a purchase order
 */

export function usePurchaseOrdersGetMaterialAvailability<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetMaterialAvailabilityQueryOptions({ identifier, id },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getPurchaseOrdersGetMaterialAvailabilitySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>({ identifier, id }: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};


  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersGetMaterialAvailabilityQueryKey({ identifier, id });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>> = ({ signal }) => purchaseOrdersGetMaterialAvailability({ identifier, id }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersGetMaterialAvailabilitySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>>
export type PurchaseOrdersGetMaterialAvailabilitySuspenseQueryError = BaseResponse


export function usePurchaseOrdersGetMaterialAvailabilitySuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMaterialAvailabilityPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMaterialAvailabilitySuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersGetMaterialAvailabilitySuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 pathParams: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the free stock in IFS of every part of a purchase order
 */

export function usePurchaseOrdersGetMaterialAvailabilitySuspense<TData = Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError = BaseResponse>(
 { identifier, id }: PurchaseOrdersGetMaterialAvailabilityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersGetMaterialAvailability>>, TError, TData>>, request?: SecondParameter<typeof apiInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersGetMaterialAvailabilitySuspenseQueryOptions({ identifier, id },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




